import { Action } from '@ngrx/store';
import { AusmitError } from "../../shared/interfaces";
import { CriteriaModel } from 'src/app/shared/interfaces/CriteriaModel';

export enum ActionTypes {
	GetCustomerOrders = 'GetCustomerOrders',
	GetCustomerOrdersSuccess = 'GetCustomerOrdersSuccess',
	GetCustomerOrdersError = 'GetCustomerOrdersError',

	CheckDeliverystatus = 'CheckDeliverystatus',
	CheckDeliverystatusSuccess = 'CheckDeliverystatusSuccess',
	CheckDeliverystatusError = 'CheckDeliverystatusError',

	GetItemOrderId = 'GetItemOrderId',
	GetItemOrderIdSuccess = 'GetItemOrderIdSuccess',
	GetItemOrderIdError = 'GetItemOrderIdError',

	CancelItemOrder = 'CancelItemOrder',
	CancelItemOrderSuccess = 'CancelItemOrderSuccess',
	CancelItemOrderError = 'CancelItemOrderError',

	GetCustomerItemDocketStatus = 'GetCustomerItemDocketStatus',
	GetCustomerItemDocketStatusSuccess = 'GetCustomerItemDocketStatusSuccess',
	GetCustomerItemDocketStatusError = 'GetCustomerItemDocketStatusError',

	OrderPostComment = 'OrderPostComment',
	OrderPostCommentSuccess = 'OrderPostCommentSuccess',
	OrderPostCommentError = 'OrderPostCommentError',
	OrderPostCommentReset = 'OrderPostCommentReset',

	OrderReview = 'OrderReview',
	OrderReviewSuccess = 'OrderReviewSuccess',
	OrderReviewError = 'OrderReviewError',

}

export class GetCustomerOrders implements Action {
	readonly type = ActionTypes.GetCustomerOrders;

	constructor(public payload: CriteriaModel) { }
}

export class GetCustomerOrdersSuccess implements Action {
	readonly type = ActionTypes.GetCustomerOrdersSuccess;

	constructor(public payload: any) { }
}

export class GetCustomerOrdersError implements Action {
	readonly type = ActionTypes.GetCustomerOrdersError;

	constructor(public payload: AusmitError) { }
}

export class CheckDeliverystatus implements Action {
	readonly type = ActionTypes.CheckDeliverystatus;

	constructor(public payload: any) { }
}

export class CheckDeliverystatusSuccess implements Action {
	readonly type = ActionTypes.CheckDeliverystatusSuccess;

	constructor(public payload: any) { }
}

export class CheckDeliverystatusError implements Action {
	readonly type = ActionTypes.CheckDeliverystatusError;

	constructor(public payload: AusmitError) { }
}

export class GetItemOrderId implements Action {
	readonly type = ActionTypes.GetItemOrderId;

	constructor(public payload: any) { }
}

export class GetItemOrderIdSuccess implements Action {
	readonly type = ActionTypes.GetItemOrderIdSuccess;

	constructor(public payload: any) { }
}


export class GetItemOrderIdError implements Action {
	readonly type = ActionTypes.GetItemOrderIdError;

	constructor(public payload: AusmitError) { }
}


export class CancelItemOrder implements Action {
	readonly type = ActionTypes.CancelItemOrder;

	constructor(public payload: any) { }
}

export class CancelItemOrderSuccess implements Action {
	readonly type = ActionTypes.CancelItemOrderSuccess;

	constructor(public payload: any) { }
}

export class CancelItemOrderError implements Action {
	readonly type = ActionTypes.CancelItemOrderError;

	constructor(public payload: AusmitError) { }
}

export class GetCustomerItemDocketStatus implements Action {
	readonly type = ActionTypes.GetCustomerItemDocketStatus;

	constructor(public payload: any) { }
}

export class GetCustomerItemDocketStatusSuccess implements Action {
	readonly type = ActionTypes.GetCustomerItemDocketStatusSuccess;

	constructor(public payload: any) { }
}


export class GetCustomerItemDocketStatusError implements Action {
	readonly type = ActionTypes.GetCustomerItemDocketStatusError;

	constructor(public payload: AusmitError) { }
}

export class OrderPostComment implements Action {
	readonly type = ActionTypes.OrderPostComment;

	constructor(public payload: any) {
	}
}

export class OrderPostCommentSuccess implements Action {
	readonly type = ActionTypes.OrderPostCommentSuccess;

	constructor(public payload: any) {
	}
}

export class OrderPostCommentError implements Action {
	readonly type = ActionTypes.OrderPostCommentError;

	constructor(public payload: AusmitError) {
	}
}

export class OrderReview implements Action {
	readonly type = ActionTypes.OrderReview;

	constructor(public payload: CriteriaModel) {
	}
}

export class OrderReviewSuccess implements Action {
	readonly type = ActionTypes.OrderReviewSuccess;

	constructor(public payload: any) {
	}
}

export class OrderReviewError implements Action {
	readonly type = ActionTypes.OrderReviewError;

	constructor(public payload: AusmitError) {
	}
}

export type Actions =
	| GetCustomerOrders
	| GetCustomerOrdersSuccess
	| GetCustomerOrdersError
	| CheckDeliverystatus
	| CheckDeliverystatusError
	| CheckDeliverystatusSuccess
	| GetItemOrderId
	| GetItemOrderIdSuccess
	| GetItemOrderIdError
	| CancelItemOrder
	| CancelItemOrderSuccess
	| CancelItemOrderError
	| GetCustomerItemDocketStatus
	| GetCustomerItemDocketStatusSuccess
	| GetCustomerItemDocketStatusError
	| OrderPostComment
	| OrderPostCommentSuccess
	| OrderPostCommentError
	| OrderReview
	| OrderReviewSuccess
	| OrderReviewError;

